import React from "react";

export const PlusIcon = ({ fill }: { fill?: string }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={fill ?? "#0A2540"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.6654 8.66634H8.66536V12.6663H7.33203V8.66634H3.33203V7.33301H7.33203V3.33301H8.66536V7.33301H12.6654V8.66634Z" />
    </svg>
  );
};
